export default __webpack_public_path__ + "static/media/play-mini-bn.7a260c28.png";